// extracted by mini-css-extract-plugin
export default {"lightTheme":"nvrt-light_theme","darkTheme":"nvrt-dark_theme","link":"link_link__7XwUs","href":"link_href__PhTJl","text":"link_text__IBYTW"};